import { Button, CoachRunDataSource, Markdown, unifyLanguageName } from "@quark/design";
import { FC, useMemo, useRef, useState } from "react";
import styles from './index.module.scss';
import LogoBlueText from "../../../icons/logo-blue-text";
import { takeSnapshot } from "../../../utils/punch";
import dayjs from "dayjs";

interface CoachPunchProps {
  dataSource: CoachRunDataSource;
  onPunch?: () => void;
}

const CoachPunch: FC<CoachPunchProps> = ({
  dataSource,
  onPunch = () => { },
}) => {
  const code = useMemo(() => {
    const { source_code = '', language = 'text' } = dataSource?.user_data || {};
    const lang = unifyLanguageName(language);
    return `\`\`\`${lang}\n${source_code}\n\`\`\``;
  }, [dataSource]);

  const cardRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);

  const downloadImage = async () => {
    if (loading) return;
    if (!cardRef.current) return;
    setLoading(true);
    // download
    const snapshot = await takeSnapshot(cardRef.current, {
      windowWidth: 320
    });
    if (!snapshot) return;
    let a = document.createElement("a");
    a.href = snapshot;
    a.download = `PythonTip打卡-${dayjs().format("YYYY-MM-DD")}.png`;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => {
      onPunch();
      setLoading(false);
    }, 1000);
  };

  return (
    <div className={styles.container}>
      <div className={styles.card} ref={cardRef}>
        <div className={styles.decoration}></div>

        <div className={styles.header}>
          <LogoBlueText />
          <div className={styles.subject}>🎊 题库挑战 🎊</div>
        </div>
        <div className={styles.title}>
          完成挑战 🎉
        </div>
        <div className={styles.name}>
          {dataSource.title} - {dataSource.difficulty}
        </div>
        <div className={styles.code}>
          <Markdown>
            {code}
          </Markdown>
        </div>

      </div>
      <div className={styles.actions}>
        <Button className={styles.action} onClick={() => downloadImage()}>
          保存图片去打卡
        </Button>
      </div>
    </div>
  )
}

export default CoachPunch;
